export default __webpack_public_path__ + "static/media/logo.9fd57e9e.png";